import { create } from "zustand";
var useAthleteStore = create(function (set) { return ({
    setPersonalData: function (personalData) { return set({ personalData: personalData }); },
    setAddressData: function (addressData) { return set({ addressData: addressData }); },
    setSchoolData: function (schoolData) { return set({ schoolData: schoolData }); },
    setLegalRepresentativeData: function (legalRepresentativeData) {
        return set({ legalRepresentativeData: legalRepresentativeData });
    },
    setTermsAndConditionsData: function (termsAndConditionsData) {
        return set({ termsAndConditionsData: termsAndConditionsData });
    },
    setCategoryAndModalityData: function (categoryAndModalityData) {
        return set({ categoryAndModalityData: categoryAndModalityData });
    },
    reset: function () {
        return set({
            personalData: undefined,
            addressData: undefined,
            schoolData: undefined,
            legalRepresentativeData: undefined,
            termsAndConditionsData: undefined,
            categoryAndModalityData: undefined,
            registrationProofSearchData: undefined,
        });
    },
}); });
export default useAthleteStore;
